import { render, staticRenderFns } from "./58baoyevideo2.vue?vue&type=template&id=e0a34da6&"
import script from "./58baoyevideo2.vue?vue&type=script&lang=js&"
export * from "./58baoyevideo2.vue?vue&type=script&lang=js&"
import style0 from "./58baoyevideo2.vue?vue&type=style&index=0&id=e0a34da6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports